import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import { TickCheck } from "../../assets/icons";

const GrandTotalMobile = ({ data, cart, onCheckout }) => {
  const [termsConditionsChecked, setTermsConditionsChecked] = useState(false);

  const getAmount = (prod) => {
    var result = prod?.reduce(function (acc, obj) {
      return acc + obj.totalPrice;
    }, 0);
    return result;
  };
  return (
    <GrandTotalContainer>
      <GrandTotalSubContainer>
        <PaymentSummaryText>Payment summary</PaymentSummaryText>
        <SubTotalDiv>
          <SubTotalText>{Text.subTotal}</SubTotalText>
          <SubTotalText>
            {Text.qar} {getAmount(data)}
          </SubTotalText>
        </SubTotalDiv>
        {cart?.discountAmount > 0 && (
          <SavingDiv>
            <SavingText>{Text.saving}</SavingText>
            <SavingText>
              -{Text.qar} {cart?.discountAmount}
            </SavingText>
          </SavingDiv>
        )}
        <GrandTotalDiv>
          <GrandTotalText>{Text.grandTotal}</GrandTotalText>
          <GrandTotalText style={{ fontWeight: "700", fontSize: "1.25rem" }}>
            {Text.qar} {cart?.finalAmount || 0}
          </GrandTotalText>
        </GrandTotalDiv>
      </GrandTotalSubContainer>
      <Line></Line>
      <TermsContainer>
        {termsConditionsChecked ? (
          <TermsTickContainerChecked
            checked={termsConditionsChecked}
            onClick={() => setTermsConditionsChecked((prev) => !prev)}
          >
            {" "}
          </TermsTickContainerChecked>
        ) : (
          <TermsTickContainer
            checked={termsConditionsChecked}
            onClick={() => setTermsConditionsChecked((prev) => !prev)}
          >
            {" "}
          </TermsTickContainer>
        )}
        <TermsTextContainer>
          I agree to the{" "}
          <TermsLink href="https://qwik.powerholding-intl.com/Content/Pages/terms.html">
            {Text.termsConditions}
          </TermsLink>{" "}
          and{" "}
          <TermsLink href="https://qwik.powerholding-intl.com/Content/Pages/privacy.html">
            {Text.privacy}
          </TermsLink>
        </TermsTextContainer>
      </TermsContainer>
      <ContinueButton
        disabled={!termsConditionsChecked}
        onClick={() => onCheckout(true)}
      >
        <ButtonTitle>{Text.proceedToCheckout}</ButtonTitle>
      </ContinueButton>
    </GrandTotalContainer>
  );
};

const TermsContainer = styled.div`
  padding: 16px;
  display: flex;
  gap: 10px;
`;

const TermsTickContainer = styled.div`
  border-radius: 8px;
  border: solid #0a0f81 3px;
  width: 20px;
  height: 20px;
  background-color: ${(props) => (props.checked ? "#0a0f81" : "transparent")};
  @media only screen and (max-width: 768px) {
    font-size: 12px;
    width: 25px;
  }
`;
const TermsTickContainerChecked = styled.div`
  border-radius: 8px;
  border: solid #0a0f81 3px;
  width: 20px;
  height: 20px;
  background-color: ${(props) => (props.checked ? "#0a0f81" : "transparent")};
  background-image: url(${TickCheck});
  @media only screen and (max-width: 768px) {
    font-size: 12px;
    width: 25px;
  }
`;

const TermsTextContainer = styled.div`
  color: ${Colors.black};
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 113.4%;
  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const TermsLink = styled.a`
  color: ${Colors.aqua};
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 113.4%;
  text-decoration-line: underline;
  text-decoration-thickness: 0.5px;
  cursor: pointer;
  @media only screen and (max-width: 768px) {
    font-size: 13px;
  }
`;

const GrandTotalContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${Colors.e8Grey};
  //   align-items: center;
  width: 100%;
  margin-top: 1rem;
  padding-bottom: 1rem;
  box-sizing: border-box;
`;
const GrandTotalSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  //   padding: 2rem 5rem 0rem 5rem;
  //   @media only screen and (max-width: 640px) {
  //     padding: 2rem 2rem 0rem 2rem;
  //   }
`;
const SubTotalDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1.5rem;
  margin-top: 0.5rem;
`;
const SavingDiv = styled(SubTotalDiv)``;
const GrandTotalDiv = styled(SubTotalDiv)`
  margin-top: 1rem;
`;

const SubTotalText = styled.span`
  color: ${Colors.secondaryBlack};
  font-size: 1rem;
  font-weight: 300;
  margin-top: 0.3rem;
`;
const SavingText = styled.span`
  color: ${Colors.parrotGreen};
  font-size: 1rem;
  font-weight: 300;
  margin-top: 0.3rem;
`;

const GrandTotalText = styled(SubTotalText)`
  font-weight: 500;
  text-align: center;
  // border: 1px solid red;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: ${Colors.rainbowGrey};
  margin-top: 1rem;
`;

const ContinueButton = styled.button`
  background: ${Colors.cyan};
  outline: none;
  display: flex;
  padding: 1rem 0.5rem;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: none;
  margin-top: 2rem;
  cursor: pointer;
  width: 90%;
  align-self: center;
  &:disabled {
    background: ${Colors.lightGrey};
    cursor: not-allowed;
  }
`;
const ButtonTitle = styled.span`
  font-size: 1rem;
  font-weight: 900;
  text-align: center;
  color: ${Colors.white};
`;
const PaymentSummaryText = styled.span`
  color: ${Colors.secondaryBlack};
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
`;

export default GrandTotalMobile;
